/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect } from 'react';
// material
import { ReactComponent as WarningIcon } from 'assets/icons/error-circle.svg'
import { ReactComponent as Comment1Icon } from 'assets/icons/comment-1.svg'
import { ReactComponent as Comment2Icon } from 'assets/icons/comment-2.svg'
import { ReactComponent as Comment3Icon } from 'assets/icons/comment-3.svg'
import { ReactComponent as Comment4Icon } from 'assets/icons/comment-4.svg'
import { ReactComponent as Comment5Icon } from 'assets/icons/comment-5.svg'
import { ReactComponent as Comment6Icon } from 'assets/icons/none.svg'
import { Radio, CopySnippetField, Tip, ToolTip } from '@insticator/insticator-ui'
import Space from 'material/space/space';
import { SectionGroupV2, ConfigToggle } from 'material/expandablesection/v2'
// styles
import injectSheet from 'react-jss'
import styles from './commentscounter_styles'
import PreviewConfig from '../../previewconfig/previewconfig';
import { Icon } from '@insticator/insticator-ui/dist/material';
import { useNavigation } from 'utils/navigation';

const icons = {
  DOUBLE_BUBBLE_RECT_DARK: <Comment1Icon />,
  SINGLE_BUBBLE_RECT_LIGHT: <Comment2Icon />,
  SINGLE_BUBBLE_ROUND_DARK: <Comment3Icon />,
  SINGLE_BUBBLE_ROUND_LIGHT: <Comment4Icon />,
  SINGLE_BUBBLE_RECT_DARK: <Comment5Icon />,
  NONE: ''
}

/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: ADVANCED SECTION : COMMENTS COUNTER ~~~~~~~~~~ ========== */
const CommentsCounter = injectSheet(styles)((props) => {

  const { useCommentsCounter, commentsCounterIconStyle, commentsCounterFormat, onChange } = props

  const handleIconChange = icon =>  onChange('commentsCounterIconStyle', icon)

  const { handleNavigation } = useNavigation()
  
  const redirectToProductManager = () => handleNavigation('/dashboard/productmanager')

  return (
    <div id="comments-counter">
    <SectionGroupV2 
      indented={true} 
      klass={`commentscounter ${props.classes.commentscounter}`} 
      title={'Comments Counter'} 
      description={<span>Display the number of comments an article has directly under its title.{' '}
       <ToolTip 
        trigger={'mouseenter'} 
        zIndex={9}
        content={
          <>
          <p>For example, this could be added on your homepage under each article preview or on an article page directly under the title. This gives additional context for the article and can increase engagement. The counter also links directly to the comments section.</p>
          <br />
          <p>You can enable or disable this feature from the <span className='productmanagerlink'  onClick={redirectToProductManager}>Product Manager</span>.</p>
        </>

        }
      >
        <Icon name={'question-circle'} />
      </ToolTip>
      </span>} 
        rowGap={32} direction={'column'}>
      {/* <ConfigToggle 
        title={'Enable comments counter'}
        checked={useCommentsCounter}
        onChange={val => onChange('useCommentsCounter', val)}
      > */}
        <Space gap={48}>
          <Space direction={'column'} gap={16}>
            <p>Choose an icon style <Tip space={'none'} icon={'question-circle'} content={'Colors will be inherited from your site and the icon you select here will also appear in the header of the comments section where the number of comments are displayed.'} label={''} /></p>
            <Space klass={'countericons'}>
              <div className={`icon selected-${commentsCounterIconStyle === 'DOUBLE_BUBBLE_RECT_DARK'}`} onClick={() => handleIconChange('DOUBLE_BUBBLE_RECT_DARK')}>
                <Comment1Icon />
              </div>
              <div className={`icon selected-${commentsCounterIconStyle === 'SINGLE_BUBBLE_RECT_LIGHT'}`} onClick={() => handleIconChange('SINGLE_BUBBLE_RECT_LIGHT')}>
                <Comment2Icon />
              </div>
              <div className={`icon selected-${commentsCounterIconStyle === 'SINGLE_BUBBLE_ROUND_DARK'}`} onClick={() => handleIconChange('SINGLE_BUBBLE_ROUND_DARK')}>
                <Comment3Icon />
              </div>
              <div className={`icon selected-${commentsCounterIconStyle === 'SINGLE_BUBBLE_ROUND_LIGHT'}`} onClick={() => handleIconChange('SINGLE_BUBBLE_ROUND_LIGHT')}>
                <Comment4Icon />
              </div>
              <div className={`icon selected-${commentsCounterIconStyle === 'SINGLE_BUBBLE_RECT_DARK'}`} onClick={() => handleIconChange('SINGLE_BUBBLE_RECT_DARK')}>
                <Comment5Icon />
              </div>
              <div className={`icon none selected-${commentsCounterIconStyle === 'NONE'}`} onClick={() => handleIconChange('NONE')}>
                <Comment6Icon />
              </div>
            </Space>
            <Space direction={'column'}>
              <span>Choose a format</span>
              <Radio 
                isList
                title={`Icon first`}
                checked={commentsCounterFormat === 'ICON_FIRST'}
                handleChange={() => onChange('commentsCounterFormat', 'ICON_FIRST')}
              />
              <Radio 
                isList
                title={`Text first`}
                checked={commentsCounterFormat === 'TEXT_FIRST'}
                handleChange={() => onChange('commentsCounterFormat', 'TEXT_FIRST')}
              />
            </Space>
            {/* TODO: PP Config - comments counter scrip/counter code (we should probably update the "Get Code" page to automatically show the comments counter code if this option is toggled on)
            <div className={'codeintegration'}>
              <p>Codes</p>
              <CopySnippetField
                title={<span>Loading script</span>}
                codeSnippet={`<script scr=’https://comment.instireviews.com/review`}
                inline
              />

              <CopySnippetField
                title={'Comments counter'}
                codeSnippet={`<a href=”{articleURL}#insticator-commenting” data-`}
                inline
              />
              <Space>
                <span style={{ flex: 'none' }}><WarningIcon /></span>
                <p>
                  Make sure you replace <b>{"{articleURL}"}</b> with the link to your specific page, and <b>{"{extPageId}"}</b> 
                  with the proper External Page ID value for the specific page. See <strong><a href="https://documentation.insticator.com/docs/configuring-add-ons" target="_blank">documentation</a></strong> for more details.
                </p>
              </Space>
            </div>
            */}
            <Space alignItems={'flex-start'}>
              <WarningIcon className='warningicon' /> 
              <p>You can also fully override these preset templates for a custom implementation that exactly matches your site style.</p>
            </Space>
          </Space>
          <PreviewConfig>
            {commentsCounterFormat === 'ICON_FIRST' && icons[commentsCounterIconStyle]}
            <div className={`commentstext`}>
              <span className={'count'}>124</span>
              <h3>Comments</h3> 
            </div>
            {commentsCounterFormat === 'TEXT_FIRST' && icons[commentsCounterIconStyle]}
          </PreviewConfig>
        </Space>
      {/* </ConfigToggle> */}
    </SectionGroupV2>
    </div>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default CommentsCounter;